import { AwEvent } from "../models/AwEvent"
import axios from "axios"
export function SendAnalytics(event: AwEvent, url: string) {
  axios({
    method: "post",
    url: url,
    data: event
  }).catch(function(error) {
    console.error(error)
  })
}
